export default __webpack_public_path__ + "static/media/licensed-bar.1e96edbd.svg";